import { action, makeObservable, observable } from 'mobx';

class UtilsStore {

  private readonly reBetModalStorageKey: string = 'reBetModalState';

  showRulesModal = false;
  showPayTableModal = false;
  doNotShowReBetModal = false;

  constructor() {
    makeObservable(this, {
      showRulesModal: observable,
      showPayTableModal: observable,
      doNotShowReBetModal: observable,
      setShowRulesModal: action,
      setShowPayTableModal: action,
      setDoNotShowReBetModal: action,
    });
    this.setDoNotShowReBetModal(this.getShowReBetModalFromLocalStorage());
  }

  setDoNotShowReBetModal = (doNotShowReBetModal: boolean) => {
    this.doNotShowReBetModal = doNotShowReBetModal;
    try {
      localStorage.setItem(this.reBetModalStorageKey, doNotShowReBetModal.toString());
    }
    catch (e) {

    }
  }

  setShowRulesModal = (showRulesModal: boolean) => {
    this.showRulesModal = showRulesModal;
  }

  setShowPayTableModal = (showPayTableModal: boolean) => {
    this.showPayTableModal = showPayTableModal;
  }

  private getShowReBetModalFromLocalStorage = (): boolean => {
    try {
      return localStorage.getItem(this.reBetModalStorageKey) === 'true';
    } catch (e) {
      return false;
    }
  }

}

export const utilsStore = new UtilsStore();
